{% block sw_cms_element_acris_blog_subtitle_preview %}
    <div class="sw-cms-el-preview-acris-blog-subtitle">
        <h3>{{ $tc('acris-blog.elements.blogSubtitle.preview.subtitle') }}</h3>
    </div>
{% endblock %}